module.exports = __webpack_public_path__ + "90b8cd144632dbd7c51c77336b7f5171.woff";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansbolditalic.woff
// module id = 674
// module chunks = 57